import React, { useCallback, useEffect, useState } from "react";
import { StoriesList } from "./StoriesList";
import { IEmbed } from "../../embeds/embedsV2/interface";
import axiosInstant from "../../../../api";
import { getVideoEmbeds } from "../../../../api/endpoints";
import type { PanelStatus } from "./panels";

interface Props {
  videoId: number;
  onCount?: (n: number) => void;
  /** Bumped by the page after a kebab action that can change story membership. */
  reloadKey?: number;
}

export function StoriesPanel({ videoId, onCount, reloadKey = 0 }: Props) {
  const [stories, setStories] = useState<Array<IEmbed>>([]);
  const [count, setCount] = useState(0);
  const [status, setStatus] = useState<PanelStatus>("loading");
  const [attempt, setAttempt] = useState(0);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  useEffect(() => {
    if (!videoId) return undefined;
    let live = true;
    setStatus("loading");
    axiosInstant
      .get(getVideoEmbeds(videoId))
      .then(({ data }) => {
        if (!live) return;
        const rows: IEmbed[] = data.rows || [];
        const total: number = data.count || 0;
        setStories(rows);
        setCount(total);
        onCount?.(total);
        setStatus("ready");
      })
      // A failure now renders the panel's error state with a retry, instead of
      // a toast plus an empty panel that reads as "this video is in no stories".
      .catch(() => {
        if (!live) return;
        setStories([]);
        setCount(0);
        setStatus("error");
      });
    return () => {
      live = false;
    };
  }, [videoId, attempt, reloadKey]);

  return <StoriesList stories={stories} count={count} status={status} onRetry={retry} />;
}
